import React, { ReactElement, memo } from "react";

const BACK_ICON_COLOR = "var(--arrow-color-env, #66686E)";

const BackIcon = ({ color = BACK_ICON_COLOR, className }: { color?: string; className?: string }): ReactElement => {
    return (
        <>
            <svg
                className={className}
                width="20"
                height="18"
                viewBox="0 0 20 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    opacity="0.9"
                    d="M6.81875 14.5714L1 8.23808M1 8.23808L6.81875 1.90475M1 8.23808L19 8.23808"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </>
    );
};

export default memo(BackIcon);
